import React, { useEffect, useRef } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Collapse,
  IconButton,
  Typography,
  Box,
  Chip,
  Divider,
  Card,
  CardContent,
  Grid,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TimerIcon from "@mui/icons-material/Timer";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CommentIcon from "@mui/icons-material/Comment";
import CallIcon from "@mui/icons-material/Call";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";
import { AGENT_OUTGOING_CALL } from "../../../../constants";
import { AGENT_INCOMMING_CALL } from "../../../../constants";

function ConnectedCallTable({
  outgoingConnected,
  connectedFilters,
  setConnectedFilters,
  filters,
  setFilters,
  setLoading,
}) {
  const empDetails = JSON.parse(localStorage.getItem("userData"));
  const calls = outgoingConnected?.connectedCalls || [];
  const totalRecords = outgoingConnected?.pagination?.totalRecords || 0;
  const currentPage =
    outgoingConnected?.pagination?.page || connectedFilters.page;
  const pageSize =
    outgoingConnected?.pagination?.pageSize || connectedFilters.pageSize;

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setConnectedFilters((prev) => ({ ...prev, page: newPage + 1 })); // API expects 1-based
  };

  const handleChangeRowsPerPage = (event) => {
    setConnectedFilters((prev) => ({
      ...prev,
      pageSize: parseInt(event.target.value, 10),
      page: 1,
    }));
  };

  function formatDateTimeCompact(isoString) {
    // Parse using Date constructor
    const date = new Date(isoString);

    if (isNaN(date)) return "-"; // fallback if invalid date

    // Get date parts
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const year = String(date.getUTCFullYear()).slice(-2); // last 2 digits

    // Get time parts
    let hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // convert 0 to 12

    return `${day}-${month}-${year}, ${hours}:${minutes}${ampm}`;
  }

  const location = useLocation();
  const navigate = useNavigate();
  // const { prevFilters } = location.state || {}; // Access prevFilters from state
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [totalCount, setTotalCount] = useState(0);
  const [openRows, setOpenRows] = useState([]); // To manage which rows are expanded

  // Filter states
  const [mobileFilter, setMobileFilter] = useState("");
  //  const [stateFilter, setStateFilter] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  const { agentName, agentNo } = useParams();

  const [callData, setCallData] = useState([]);

  // State options for dropdown (you can modify this list as needed)
  const stateOptions = [
    "AP",
    "OD",
    "TN",
    "RJ",
    "GJ",
    "HR",
    "PN",
    "KT",
    "WB",
    "CG",
  ];

  // const fetchConnectedData = () => {
  //   const { startDate, endDate } = filters;

  //   // Determine yesterday's date
  //   const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

  //   // Format startDate and endDate, defaulting to yesterday if not provided
  //   const formattedStartDate = startDate
  //     ? dayjs(startDate).format("YYYY-MM-DD")
  //     : yesterday;
  //   const formattedEndDate = endDate
  //     ? dayjs(endDate).format("YYYY-MM-DD")
  //     : yesterday;

  //   // Build query params
  //   const queryParams = new URLSearchParams();
  //   queryParams.append("startDate", formattedStartDate);
  //   queryParams.append("endDate", formattedEndDate);

  //   // if (localStorage.getItem("empRole") === "1") {
  //   //   queryParams.append("agentNumber", empDetails?.EmployeePhone);
  //   // } else {
  //   //   queryParams.append("agentNumber", 7880162561); // Default agent number (Pollai Hari)
  //   // }

  //   if (localStorage.getItem("empRole") === "1") {
  //     queryParams.append("agentNumber", empDetails?.EmployeePhone);
  //   }

  //   queryParams.append("callStatus", "Connected");
  //   queryParams.append("page", page + 1); // Current page (1-based index)
  //   queryParams.append("pageSize", rowsPerPage); // Number of rows per page

  //   // Add filter parameters
  //   // if (mobileFilter.trim()) {
  //   //   queryParams.append("bPartyNo", mobileFilter.trim());
  //   // }
  //   // if (stateFilter) {
  //   //   queryParams.append("state", stateFilter);
  //   // }

  //   setLoading(true);
  //   axios
  //     .get(`${AGENT_OUTGOING_CALL}?${queryParams.toString()}`)
  //     .then((response) => {
  //       console.log(response);
  //       const { connected, pagination, summary } = response.data;

  //       setCallData(connected); // Update the call data
  //       console.log('calls----:::',connected);

  //       setTotalCount(pagination.totalRecords); // Update the total record count
  //       setMetricData(summary);
  //       if ((page * rowsPerPage) >= pagination.totalRecords && page !== 0) {
  //         setPage(0);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching connected data:", error);
  //       setCallData([]); // Set call data to empty on error
  //       setLoading(false);
  //     });
  // };

  // Initialize filters with prevFilters
  // useEffect(() => {
  //   if (localStorage.getItem("empRole") === "1") {
  //     if (prevFilters) {
  //       console.log("Applying prevFilters:", prevFilters);
  //       setFilters(prevFilters);
  //     } else {
  //       // Default to the last 7 days
  //       setFilters({
  //         startDate: dayjs().subtract(7, "days").format("YYYY-MM-DD"),
  //         endDate: dayjs().format("YYYY-MM-DD"),
  //       });
  //     }
  //     isInitialLoad.current = false; // Mark initial load as complete
  //   }
  // }, [prevFilters]);

  // Fetch data when filters, page, rowsPerPage, mobileFilter, or stateFilter change

  //   useEffect(() => {
  //   if (localStorage.getItem("empRole") === "1") {
  //     if (isInitialLoad.current || !filters.startDate || !filters.endDate) {
  //       return; // Skip if it's the initial load or filters are incomplete
  //     }
  //     console.log("Fetching data with filters:", filters);
  //     fetchConnectedData();
  //   }
  // }, [filters, page, rowsPerPage, mobileFilter, stateFilter]);

  // Handle page change

  // useEffect(() => {
  //   if (!filters.startDate || !filters.endDate) return; // validate filters
  //   fetchConnectedData();
  // }, [filters, page, rowsPerPage, refetchToggle]); //

  // Handle rows per page change
  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0); // Reset to the first page
  // };

  // Handle row expansion toggle
  const handleRowToggle = (index) => {
    setOpenRows((prev) => {
      if (prev.includes(index)) {
        return prev.filter((rowIndex) => rowIndex !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const handleCallIconClick = (row) => {
    navigate("/dashboard", {
      state: {
        mobNo: row.callerNumber,
        lotNum: row.callerNumber,
        missedCallId: row.id,
      },
    });
  };

  // Handle filter clear
  // const handleClearFilters = () => {
  //   setMobileFilter("");
  //   setStateFilter("");
  //   setPage(0); // Reset to first page
  // };

  // Handle mobile filter change
  const handleMobileFilterChange = (event) => {
    setMobileFilter(event.target.value);
    setPage(0); // Reset to first page when filter changes
  };

  // Handle state filter change
  // const handleStateFilterChange = (event) => {
  //   setStateFilter(event.target.value);
  //   setPage(0); // Reset to first page when filter changes
  // };

  const IconCell = ({ row }) => (
    <Button
      variant="contained"
      size="small"
      startIcon={<CallIcon />}
      onClick={() => handleCallIconClick(row)}
      sx={{
        minWidth: "auto",
        px: 1.5,
        py: 0.5,
        borderRadius: 2,
        fontSize: "0.75rem",
        fontWeight: 600,
        textTransform: "none",
        boxShadow: 1,
        "&:hover": {
          boxShadow: 2,
          transform: "translateY(-1px)",
        },
        transition: "all 0.2s ease",
      }}
    >
      Call
    </Button>
  );

  const formatDate = (dateString) =>
    moment(dateString).format("DD-MM-YYYY HH:mm:ss");

  const getDurationColor = (duration) => {
    if (!duration || duration === "-") return "default";
    const durationNum = parseFloat(duration);
    if (durationNum < 2) return "error";
    if (durationNum < 5) return "warning";
    return "success";
  };

  const InfoItem = ({ icon, label, value }) => (
    <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minWidth: 140,
          color: "text.secondary",
          fontSize: "0.875rem",
          fontWeight: 500,
        }}
      >
        {icon}
        <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
          {label}:
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ ml: 1, fontWeight: 400 }}>
        {value || "-"}
      </Typography>
    </Box>
  );

  return (
    <>
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
        {/* Filter Section */}
        <Box
          sx={{
            p: 2,
            backgroundColor: "grey.50",
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: showFilters ? 2 : 0,
            }}
          >
            <Typography
              variant="h6"
              sx={{ display: "flex", alignItems: "center", fontWeight: 600 }}
            >
              <PhoneIcon sx={{ mr: 1, color: "primary.main" }} />
              Connected Calls
            </Typography>
            {/* <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => setShowFilters(!showFilters)}
              size="small"
              sx={{ textTransform: 'none' }}
            >
              {showFilters ? 'Hide Filters' : 'Show Filters'}
            </Button> */}
          </Box>

          {/* <Collapse in={showFilters}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}> */}
          {/* <TextField
                label="Mobile Number"
                value={mobileFilter}
                onChange={handleMobileFilterChange}
                placeholder="Enter mobile number"
                size="small"
                InputProps={{
                  startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                }}
                sx={{ minWidth: 200 }}
              /> */}

          {/* <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>State</InputLabel>
                <Select
                  value={stateFilter}
                  onChange={handleStateFilterChange}
                  label="State"
                >
                  <MenuItem value="">
                    <em>All States</em>
                  </MenuItem>
                  {stateOptions.map((state) => (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}

          {/* {(mobileFilter || stateFilter) && (
                <Button
                  variant="outlined"
                  startIcon={<ClearIcon />}
                  onClick={handleClearFilters}
                  size="small"
                  color="error"
                  sx={{ textTransform: 'none' }}
                >
                  Clear Filters
                </Button>
              )} */}
        </Box>

        {/* Active filters display */}
        {/* {(mobileFilter || stateFilter) && (
              <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                <Typography variant="body2" sx={{ color: 'text.secondary', mr: 1 }}>
                  Active Filters:
                </Typography>
                {mobileFilter && (
                  <Chip
                    label={`Mobile: ${mobileFilter}`}
                    size="small"
                    color="primary"
                    variant="outlined"
                    onDelete={() => setMobileFilter("")}
                  />
                )}
                {stateFilter && (
                  <Chip
                    label={`State: ${stateFilter}`}
                    size="small"
                    color="primary"
                    variant="outlined"
                    onDelete={() => setStateFilter("")}
                  />
                )}
              </Box>
            )} */}
        {/* </Collapse>
        </Box> */}

        <TableContainer component={Paper} elevation={0}>
          <Table
            sx={{
              minWidth: 650,
              height: "100%",
              tableLayout: "fixed",
            }}
            aria-label="connected calls table"
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "primary.main",
                  "& .MuiTableCell-head": {
                    color: "white",
                    fontWeight: 600,
                    fontSize: "0.875rem",
                  },
                }}
              >
                <TableCell width={60} sx={{ textAlign: "center" }} />
                {/* <TableCell
                  width={60}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  S.No
                </TableCell>
                  <TableCell
                  width={150}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <PersonIcon sx={{ mr: 1, fontSize: 18 }} />
                    Call Type
                  </Box>
                </TableCell> */}
                <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PersonIcon sx={{ mr: 1, fontSize: 18 }} />
                    Customer Name
                  </Box>
                </TableCell>
                <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PhoneIcon sx={{ mr: 1, fontSize: 18 }} />
                    Mobile Number
                  </Box>
                </TableCell>

                <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PersonIcon sx={{ mr: 1, fontSize: 18 }} />
                    Region Name{" "}
                  </Box>
                </TableCell>
                <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PersonIcon sx={{ mr: 1, fontSize: 18 }} />
                    Category
                  </Box>
                </TableCell>
                <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <MoreHorizIcon sx={{ mr: 1, fontSize: 18 }} />
                    Date
                  </Box>
                </TableCell>
                <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PersonIcon sx={{ mr: 1, fontSize: 18 }} />
                    Sub-Category{" "}
                  </Box>
                </TableCell>
                {/* <TableCell
                  width={160}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <AccessTimeIcon sx={{ mr: 1, fontSize: 18 }} />
                    Start Time
                  </Box>
                </TableCell> */}
                {/* <TableCell
                  width={160}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <AccessTimeIcon sx={{ mr: 1, fontSize: 18 }} />
                    End Time
                  </Box>
                </TableCell> */}
                {/* <TableCell
                  width={140}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <TimerIcon sx={{ mr: 1, fontSize: 18 }} />
                    Duration (Min)
                  </Box>
                </TableCell> */}
                {/* <TableCell
                  width={140}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <TimerIcon sx={{ mr: 1, fontSize: 18 }} />
                    Action
                  </Box>
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(calls) && calls.length > 0 ? (
                calls.map((row, rowIndex) => (
                  <React.Fragment key={rowIndex}>
                    <TableRow
                      sx={{
                        "&:hover": { backgroundColor: "action.hover" },
                        backgroundColor:
                          rowIndex % 2 === 0 ? "grey.50" : "white",
                        transition: "background-color 0.2s ease",
                      }}
                    >
                      <TableCell sx={{ padding: 1 }}>
                        <IconButton
                          onClick={() => handleRowToggle(rowIndex)}
                          sx={{
                            padding: 1,
                            transition: "transform 0.2s ease",
                            "&:hover": {
                              backgroundColor: "primary.main",
                              color: "white",
                              transform: "scale(1.1)",
                            },
                          }}
                        >
                          {openRows.includes(rowIndex) ? (
                            <ExpandLessIcon />
                          ) : (
                            <ExpandMoreIcon />
                          )}
                        </IconButton>
                      </TableCell>
                      {/* <TableCell sx={{ textAlign: "center", padding: 2, fontWeight: 500 }}>
                        <Chip
                                   label={(currentPage - 1) * pageSize + (rowIndex + 1)}

                           size="small"
                          variant="outlined"
                          color="primary"
                        />
                      </TableCell> */}
                      {/* <TableCell sx={{ textAlign: "center", padding: 2, fontWeight: 500 }}>
                        {row.leadDetail?.call_type
 || "-"}
   
                      </TableCell> */}
                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontWeight: 500,
                        }}
                      >
                        {row.leadDetail?.CustomerName || "-"}
                      </TableCell>

                      <TableCell sx={{ textAlign: "center", padding: 2 }}>
                        {row.leadDetail?.MobileNo || "-"}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontWeight: 500,
                        }}
                      >
                        {row.leadDetail?.region_name || "-"}
                      </TableCell>

                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontSize: "0.875rem",
                        }}
                      >
                        {row.leadDetail?.category || "-"}
                      </TableCell>

                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontSize: "0.875rem",
                        }}
                      >
                        {formatDateTimeCompact(row.callStartTime) || "-"}
                      </TableCell>

                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontSize: "0.875rem",
                        }}
                      >
                        {row.leadDetail?.sub_category || "-"}
                      </TableCell>
                      {/* <TableCell sx={{ textAlign: "center", padding: 2 }}>
                        <Chip
                          label={row.duration || "-"}
                          size="small"
                          color={getDurationColor(row.duration)}
                          variant="filled"
                        />
                      </TableCell> */}
                      {/* <TableCell
                        align="center"
                        sx={{
                          width: "100px",
                          padding: 2,
                          position: "sticky",
                          right: 0,
                          backgroundColor: rowIndex % 2 === 0 ? "grey.50" : "white",
                          zIndex: 10,
                          boxShadow: "-2px 0 4px rgba(0,0,0,0.1)",
                          transition: 'background-color 0.2s ease',
                        }}
                      >
                        {row.agentCallDetails?.status === "Open" ? (localStorage.getItem("empRole") === "1") && (
                          <IconCell row={row} />
                        ) : "-"}
                      </TableCell> */}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        sx={{ paddingBottom: 0, paddingTop: 0, border: 0 }}
                      >
                        <Collapse
                          in={openRows.includes(rowIndex)}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Box sx={{ margin: 2 }}>
                            <Card elevation={1} sx={{ borderRadius: 2 }}>
                              <CardContent sx={{ p: 3 }}>
                                <Typography
                                  variant="h6"
                                  sx={{
                                    mb: 2,
                                    color: "primary.main",
                                    fontWeight: 600,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <PersonIcon sx={{ mr: 1 }} />
                                  Customer Details
                                </Typography>
                                <Divider sx={{ mb: 2 }} />

                                <Grid container spacing={3}>
                                  <Grid item xs={12} md={6}>
                                    {/* <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="Farmer Village"
                                      value={row.shrimpFeedDetails?.farmerVillage}
                                    /> */}
                                    <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="Region"
                                      value={row.leadDetail?.region_name}
                                    />
                                    {/* <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="Zone"
                                      value={row.leadDetail?.Zone}
                                    /> */}
                                    <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="State"
                                      value={row.leadDetail?.state_name}
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="Postal Code"
                                      value={row.leadDetail?.pincode}
                                    />
                                    <InfoItem
                                      icon={<CommentIcon fontSize="small" />}
                                      label="Remarks"
                                      value={row.leadDetail?.agent_remark}
                                    />
                                    {/* <InfoItem
                                      icon={<CommentIcon fontSize="small" />}
                                      label="Feed Type"
                                      value={row.shrimpFeedDetails?.feedType}
                                    /> */}
                                    {/* <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                                      <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        minWidth: 140,
                                        color: 'text.secondary',
                                        fontSize: '0.875rem',
                                        fontWeight: 500
                                      }}>
                                        <CommentIcon fontSize="small" />
                                        <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
                                          Status:
                                        </Typography>
                                      </Box>
                                      <Chip
                                        label={row.shrimpFeedDetails?.status || "-"}
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                        sx={{ ml: 1, textTransform: 'capitalize' }}
                                      />
                                    </Box> */}
                                  </Grid>
                                </Grid>

                                <Typography
                                  variant="h6"
                                  sx={{
                                    mt: 3,
                                    mb: 2,
                                    color: "primary.main",
                                    fontWeight: 600,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <CommentIcon sx={{ mr: 1 }} />
                                  Remarks
                                </Typography>
                                <Divider sx={{ mb: 2 }} />

                                {Array.isArray(row.agentCallDetails?.remarks) &&
                                row.agentCallDetails.remarks.length > 0 ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 2,
                                    }}
                                  >
                                    {row.agentCallDetails.remarks.map(
                                      (remark, idx) => (
                                        <Card
                                          key={remark.id || idx}
                                          elevation={0}
                                          sx={{
                                            backgroundColor: "grey.50",
                                            border: "1px solid",
                                            borderColor: "grey.200",
                                            borderRadius: 2,
                                          }}
                                        >
                                          <CardContent sx={{ p: 2 }}>
                                            <Grid container spacing={2}>
                                              <Grid item xs={12} md={6}>
                                                <InfoItem
                                                  label="Name"
                                                  value={remark.name}
                                                />
                                                <InfoItem
                                                  label="Type"
                                                  value={remark.type}
                                                />
                                                <InfoItem
                                                  label="Pond Location"
                                                  value={remark.pondLocation}
                                                />
                                                <InfoItem
                                                  label="Category"
                                                  value={
                                                    remark.prospectFarmerCategory
                                                  }
                                                />
                                                <InfoItem
                                                  label="District"
                                                  value={remark.district}
                                                />
                                                <InfoItem
                                                  label="Current Feed Used"
                                                  value={remark.currentFeedUsed}
                                                />
                                                <InfoItem
                                                  label="Fish Species"
                                                  value={remark.fishSpecies}
                                                />
                                                <InfoItem
                                                  label="Number of Ponds"
                                                  value={remark.numberOfPonds}
                                                />
                                                <InfoItem
                                                  label="Area of Ponds (acres)"
                                                  value={remark.pondAreaInAcres}
                                                />
                                                <InfoItem
                                                  label="Stocking (Yes/No)"
                                                  value={remark.isStocking}
                                                />
                                              </Grid>
                                              <Grid item xs={12} md={6}>
                                                <InfoItem
                                                  label="Stocking Density"
                                                  value={remark.stockingDensity}
                                                />
                                                <InfoItem
                                                  label="Days of Culture"
                                                  value={remark.daysOfCulture}
                                                />
                                                <InfoItem
                                                  label="Harvesting (Yes/No)"
                                                  value={remark.isHarvesting}
                                                />
                                                <InfoItem
                                                  label="Harvesting Quantity"
                                                  value={
                                                    remark.harvestingQuantity
                                                  }
                                                />
                                                <InfoItem
                                                  label="Potential (MT)"
                                                  value={
                                                    remark.potentialityInMT
                                                  }
                                                />
                                                <InfoItem
                                                  label="Status"
                                                  value={remark.status}
                                                />
                                                <InfoItem
                                                  label="Purpose"
                                                  value={remark.purpose}
                                                />
                                                <InfoItem
                                                  label="Agent Remarks"
                                                  value={remark.agentRemarks}
                                                />
                                                <InfoItem
                                                  label="Call Type"
                                                  value={remark.callType}
                                                />
                                                <InfoItem
                                                  label="FollowUp Date"
                                                  value={
                                                    remark.followUpDate
                                                      ? moment(
                                                          remark.followUpDate
                                                        ).format(
                                                          "DD-MM-YYYY HH:mm:ss"
                                                        )
                                                      : "-"
                                                  }
                                                />
                                                <InfoItem
                                                  label="Created At"
                                                  value={
                                                    remark.createdAt
                                                      ? moment(
                                                          remark.createdAt
                                                        ).format(
                                                          "DD-MM-YYYY HH:mm:ss"
                                                        )
                                                      : "-"
                                                  }
                                                />
                                              </Grid>
                                            </Grid>
                                          </CardContent>
                                        </Card>
                                      )
                                    )}
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      textAlign: "center",
                                      py: 3,
                                      color: "text.secondary",
                                      backgroundColor: "grey.50",
                                      borderRadius: 2,
                                      border: "1px dashed",
                                      borderColor: "grey.300",
                                    }}
                                  >
                                    <CommentIcon
                                      sx={{ fontSize: 48, mb: 1, opacity: 0.5 }}
                                    />
                                    <Typography variant="body1">
                                      No remarks available
                                    </Typography>
                                  </Box>
                                )}
                              </CardContent>
                            </Card>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 6 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        paddingLeft: "150px",
                        color: "text.secondary",
                      }}
                    >
                      <PhoneIcon sx={{ fontSize: 64, mb: 2, opacity: 0.3 }} />
                      <Typography variant="h6" sx={{ mb: 1 }}>
                        No Call Details Available
                      </Typography>
                      <Typography variant="body2">
                        There are no connected calls to display for the selected
                        period.
                      </Typography>
                      {/* {(mobileFilter || stateFilter) && (
                        <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
                          Try adjusting your filters to see more results.
                        </Typography>
                      )} */}
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalRecords} // total unique calls
          page={currentPage - 1} // convert to 0-based
          onPageChange={handleChangePage}
          rowsPerPage={pageSize}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            borderTop: "1px solid",
            borderColor: "divider",
            backgroundColor: "grey.50",
          }}
        />
      </Paper>
    </>
  );
}

export default ConnectedCallTable;
